// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__135kc","colBig":"styles_colBig__3qaX5","colSmall":"styles_colSmall__2z2v3","shopifyNameWrapper":"styles_shopifyNameWrapper__3it7v"};